/* eslint-disable class-methods-use-this */
import { assignIn } from 'lodash';
import { notificationModuleName as notificationModule } from '@jumpcloud/ui-notifications';
import { trialFeatures } from 'client/util/Constants/FeatureTrialConstants';
import CloudInsightsAccountsApi from 'client/api/v2/CloudInsightsAccountsApi';
import CollectionModule from 'client/store/modules/CollectionModule';
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export class CloudInsightsAccountsCollection extends CollectionModule {
  constructor() {
    super(CloudInsightsAccountsApi, '_id');
  }

  get module() {
    const defaultModule = super.extractModule();

    assignIn(defaultModule.state, {
      isLoading: false,
    });

    assignIn(defaultModule.actions, {
      fetchCollection: this.fetchAccountList.bind(this),
      deleteItem: this.deleteAccount.bind(this),
    });

    assignIn(defaultModule.mutations, {
      SET_LOADING_STATE: this.SET_LOADING_STATE,
    });

    return defaultModule;
  }

  async fetchAccountList(context, params) {
    const { commit, dispatch } = context;

    commit('SET_LOADING_STATE', true);

    try {
      await super.fetchCollection(context, params);
    } catch {
      dispatch(`${notificationModule}/triggerErrorNotification`, {
        title: 'Error',
        message: 'Unable to fetch accounts.',
      }, { root: true });
      commit('SET_LOADING_STATE', false);

      return;
    }

    commit('SET_LOADING_STATE', false);
  }

  async deleteAccount(context, { accountID, awsAccountNumber }) {
    const { dispatch, state } = context;
    try {
      // Cloud Insights does not delete accounts, just deactivates
      await super.updateItem(context, {
        id: accountID,
        attributes: {
          isActivated: 'false',
          isValidated: 'false',
        },
      });

      const currentCollectionState = super.getCollection(state);
      const inactiveAccounts = currentCollectionState.filter(account => 'isActivated' in account && account.isActivated === 'false');
      const areAllAccountsDeactivated = currentCollectionState.length === 0
        || inactiveAccounts.length === currentCollectionState.length;

      if (areAllAccountsDeactivated) {
        dispatch('FeatureTrialModule/fetchFeatureUsage', { featureCode: trialFeatures.cloudInsights.featureCode }, { root: true });
      }
    } catch (e) {
      dispatch(`${notificationModule}/triggerErrorNotification`, {
        title: 'Error',
        message: 'Unable to delete account.',
      }, { root: true });

      return;
    }
    // On success, remove item from store
    context.commit('DELETE_ITEMS', [accountID]);

    dispatch(`${notificationModule}/triggerSuccessNotification`, {
      title: `AWS account ${awsAccountNumber} deleted.`,
    }, { root: true });
  }

  SET_LOADING_STATE(state, isLoading) {
    Vue.set(state, 'isLoading', isLoading);
  }
}

export default new CloudInsightsAccountsCollection().module;
